@if (institutionId > 0) {
  <div id="submodule-product-analysis" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <h2>{{ 'MODULES.INSTITUTIONS.PRODUCTSALES.HEADER' | translate }}</h2>
    </div>
    <!-- Grid (zeigt Kontakte der aktuellen Einrichtung) -->
    <phscw-grid
      #gridInstitutionsProductAnalysis
      gridId="gridInstitutionsProductAnalysis"
      [simpleGrid]="true"
      [loading]="loading"
      [gridData]="data"
      [gridColumns]="gridColumns"
      [gridDisplayedColumns]="gridDisplayedColumns">
    </phscw-grid>
    <br />
    <div
      class="cw-link"
      (click)="customSalesAnalysisProductViewNavigation('sales/sales-products-analysis', institutionId)">
      <p><span class="icon-chart-pie"></span> {{ 'SHARED.OVERLAY.INFO.SWITCHTOPRODUCTANALYSIS' | translate }}</p>
    </div>
  </div>
}
